import defaultLayout from '../../../layouts/default'
import store from '../../../store'

export default {
  path: 'card',
  component: defaultLayout,
  children: [
    {
      path: 'view',
      component: () => import('./view/cardList.vue'),
      meta: {
        activeMenu: 'card',
        auth: true
      },
      beforeEnter(to, from, next) {
        const privilege_info = store.state.user?.user_info?.privilege_info
        if (!privilege_info) {
          next({ path: '/user/login', replace: true })
          return
        }
        if (privilege_info.show_company_cardholder === 'y') {
          next()
        } else if (privilege_info.show_manage == 'y') {
          next({ path: '/admin/accountinfo' })
        } else {
          next({ path: '/noPermission' })
        }
      }
    },
    {
      path: 'merge',
      component: () => import('./merge/merge.vue'),
      meta: {
        activeMenu: 'card',
        auth: true
      }
    },
    {
      path: 'help',
      component: () => import('./help'),
      meta: {
        activeMenu: 'card',
        auth: true
      }
    },
    {
      path: 'edit',
      component: () => import('./edit')
    }
  ]
}
